const whiteBrandTheme = {
  companyName: "Caja Digital Bancaribe",
  currencyDefault: "VES",
  companyLanguage: "es",
  companyFavicon: "bancaribe/favicon.ico",
  companyPrimaryLogo: "bancaribe/bigLogo.svg",
  companyPrimaryLogoPng: "bancaribe/logo.png",
  companySecondaryLogo: "bancaribe/whiteLogo.svg",
  companyLoaddingLogo: "bancaribe/Icon.png",
  companyLoginLateralImage: "bancaribe/lateralImgLogin.png",
  companyLoginLateralImageBg: "#00205B",
  companyPrimaryColor: "#00D8D8",
  companySecondaryColor: "#00D8D8",
  companyTerceariColor: "#00D8D8",
  companyPrimaryGreyColor: "#2E2E2E",
  companyMainSuccessColor: "#73B736",
  companyLightSuccessColor: "#73B736",
  companyDarkSuccessColor: "#73B736",
  companyContrastTextSuccessColor: "#FFFFFF",
  companyMainErrorColor: "#D40000",
  companyLightErrorColor: "#D40000",
  companyDarkErrorColor: "#D40000",
  companyContrastTextErrorColor: "#FFFFFF",
  contrastText: "#FFFFFF",
  companyTextPrimaryColor: "#2E2E2E",
  companyTextSecondaryColor: "#2E2E2E",
  companyContainedColorBtn:"linear-gradient(90deg, #00D8D8 -10.45%, #00D8D8 100%)",
  companyContainedBoxShadowBtn: "rgba(0, 0, 0, 0.2)",
  companySidebarColor: "#00205B",
};

export default whiteBrandTheme;
